// extracted by mini-css-extract-plugin
export default {"bodyContainer":"ScrollableBodyContainer_bodyContainer__Ft+gP"};